import { SortMenuController } from "./sort-menu.controller";

angular.module("thor.shared.sort-menu.component", [])
    .component("sortMenu", {
        bindings: {
            context: "<",
            onSort: "&",
            sortParams: "<",
            sortTypes: "<?"
        },
        controller: SortMenuController,
        controllerAs: "sortMenuCtrl",
        template: require("../../shared/sort-menu/sort-menu.html")
    });
